import * as React from 'react';
import { PiralDocsBreadcrumbsComponentProps } from '../scripts/types';

// tslint:disable-next-line:no-null-keyword
const Breadcrumbs: React.FC<PiralDocsBreadcrumbsComponentProps> = () => null;

export default Breadcrumbs;
